import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../parcel-tracking-modals.scss";
import { Button, TextInput, DataTable } from "@life-line-lab/components-react";
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

interface AddToBatchModalProps {
  onSubmit: any;
  handleCancel: any;
  selectedOrders?: any;
  allBatchesList?: any;
  onSearch?: any;
}

const AddToBatchModal: React.FC<AddToBatchModalProps> = ({
  handleCancel,
  selectedOrders,
  allBatchesList,
  onSubmit,
  onSearch,
}) => {
  const { t } = useTranslation();
  const initialInput = {};
  const initialError = {};
  const [input, setInput] = useState(initialInput);
  const [error, setError] = useState<any>(initialError);
  const [selectedBatch, setSelectedBatch] = useState<string>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(initialError);
    setInput({ ...input, [e.target.name]: e.target.value });
    onSearch(input);
  };

  const rowSelection: any = {
    onChange: (selectedRows: any) => {
      setSelectedBatch(selectedRows[0]);
    },
    getCheckboxProps: (record) => {
      return {
        disabled: record.status === "CLOSED",
      };
    },
    type: "radio",
  };

  const handleSubmit = () => {
    onSubmit(selectedBatch, selectedOrders);
  };

  const columns: any = [
    {
      title: t("label.batchNo").toLocaleUpperCase(),
      dataIndex: ["batchCode"],
    },
    {
      title: t("label.noOfParcel").toLocaleUpperCase(),
      dataIndex: "noOfParcels",
      ellipsis: true,
    },
    {
      title: t("label.cubicVolume").toLocaleUpperCase(),
      dataIndex: "totalVolume",
      ellipsis: true,
      render: (_: any, record: any) => {
        return <span>{parseInt(record.totalVolume).toLocaleString()}</span>;
      },
    },
    {
      title: t("label.originHub").toLocaleUpperCase(),
      dataIndex: ["sortingHubData", "name"],
      ellipsis: true,
    },
    {
      title: t("label.handoverPoint").toLocaleUpperCase(),
      dataIndex: ["handoverPointData", "name"],
      ellipsis: true,
    },
  ];

  return (
    <div className="parcel-tracking-modal">
      <ModuleTitleBar titleText={t("title.addToBatch").toUpperCase()} />
      <strong>{t("title.searchBatch").toUpperCase()}</strong>
      <div className="mt-10 mb-10">
        <TextInput
          isRequired={true}
          isError={!!error.batchNo}
          placeholder={t("placeholder.searchBatchNo")}
          name="batchNo"
          // value={input.batchNo}
          onChange={handleChange}
        />
      </div>
      <DataTable
        rowKey={(record: any, i) => record._id}
        // columns={columns as any}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={allBatchesList || []}
        scroll={{ x: true }}
      />
      <div className="mt-30 right">
        <Button
          type={"primary"}
          label={t("action.confirm")}
          onClick={handleSubmit}
        />
        <Button
          className="cancel-btn"
          type={"default"}
          label={t("action.cancel")}
          onClick={handleCancel}
        />
      </div>
    </div>
  );
};

export default AddToBatchModal;
